var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getApiClient } from "../../services/AxiosClients";
import FetchService from "./Shared/FetchService";
export default class DashboardService {
    static getDashboards() {
        return __awaiter(this, void 0, void 0, function* () {
            const apiClient = getApiClient();
            const response = yield apiClient.get("/dashboards/search/all");
            return response.data._embedded.dashboards;
        });
    }
    static getDefaultDashboard() {
        return __awaiter(this, void 0, void 0, function* () {
            const dashboard = yield FetchService.getSingleResponse("/aviso/advisor/getDefaultDashboard");
            return dashboard;
        });
    }
    static getDashboardWidgets() {
        return __awaiter(this, void 0, void 0, function* () {
            const widgets = yield FetchService.getSingleResponse("/aviso/advisor/getWidgets");
            return Object.values(widgets);
        });
    }
    static getDashboardLayouts() {
        return __awaiter(this, void 0, void 0, function* () {
            const apiClient = getApiClient();
            const dashboardLayoutResponse = yield apiClient.get("/dashboardLayouts?sort=id");
            return dashboardLayoutResponse.data._embedded.dashboardLayouts;
        });
    }
}
